document.querySelectorAll(".block_faq_wrapper_content").forEach(function (section) {
  var faqHeadings = section.querySelectorAll(".block_faq__heading");
  faqHeadings.forEach(function (heading) {
    heading.addEventListener("click", function () {
      if (heading.classList.contains("active")) {
        heading.nextElementSibling.style.display = "none";
        heading.classList.remove("active");
      } else {
        heading.nextElementSibling.style.display = "block";
        heading.classList.add("active");
      }
    });
  });
});
